<template>
  <content-panel style="margin: 0">
    <template v-slot:search>
      <!--搜索-->
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="70px" :model="searchForm" :rules="rules" ref="searchForm">
          <div class="search-row">
            <el-form-item label="文件名:" prop="employeeNo">
              <el-input v-model.trim="searchForm.fileName" placeholder="请输入文件名" @keyup.enter.native="onSearchList"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearchList">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <!-- <el-button type="primary" size="mini" class="green-btn" @click="uploadRecordsVisable = true">批量上传记录 </el-button> -->
        <el-button type="primary" size="mini" class="green-btn" @click="bacthoPeration(1)">下载 </el-button>
        <el-button type="warning" size="mini" @click="bacthoPeration">删除 </el-button>
      </template>
      <el-table
        @select="serlectRow"
        ref="tableRef"
        :height="maxTableHeight"
        border
        :data="tableData.list || []"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%"
        v-loading="loading"
        @sort-change="handleSortChange"
        @selection-change="handleSelectionChange"
        :row-key="
          (row) => {
            return row.dataId;
          }
        "
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="预览" width="100">
          <template slot-scope="scope">
            <el-image
            style="width: 79px; height: 52px"
            :src="scope.row.filePath"
            :preview-src-list="imgList"
            :initial-index="scope.$index"
            fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fileName" min-width="380" label="文件名">
          <template slot-scope="scope">
            <template v-if="scope.row.filePath">
              <el-link :underline="false" type="primary" @click="videoShow(scope.row,scope.$index)">{{ scope.row.fileName }}</el-link>
            </template>
            <template v-else>{{ scope.row.fileName }}</template>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="creationDate" label="上传时间" min-width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="userName" label="上传人" min-width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="businessType" label="类型" min-width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fileSize" label="大小" min-width="80"></el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="downLoadRequest(scope.row.filePath, scope.row.fileName)">下载</el-button>
            <el-button type="text" @click="del(scope.row)" v-permission="`ec-pc-new$pageMaterialManagement$filmRepairManagement$ProductShootingImageManagement$repairFilmDel`">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-footer height="auto" style="text-align: right; padding: 5px 0">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </table-panel>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" v-if="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList" :imgIndex="imgIndex"></imgShow></el-dialog>
    <!-- 批量上传记录 -->
    <!-- <upload-records :visible.sync="uploadRecordsVisable" :foldId="foldId"  v-if="uploadRecordsVisable"/> -->
  </content-panel>
</template>
<script>
import imgShow from './imgShow';
// import uploadRecords from './uploadRecords';
import moment from 'moment';
import axios from '@/utils/axiosInstance';
import tableMixin from '@/utils/tableMixin';
import Tiff from 'tiff.js'
export default {
  name: 'fileManagement',
  components: { imgShow },
  mixins: [tableMixin],
  data() {
    return {
      tableHeight: null,
      loading: true,
      loadingAll: false,
      titleName: '',
      showFlag: false,
      searchForm: {},
      rules: {},
      requestParam: {},
      imgFormVisible: false,
      uploadRecordsVisable: false,
      imgList: [],
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: 'auto',
      params: {
        headers: {
          'Content-Type': 'application/json;charset=utf-8', // 根据后台的接参数方式前端指定请求头
        },
      },
      radio: null,
      selectSpus: [],
      onRemoveSpuIds: [],
      queryCriteria: [],
      foldId: '',
      fliePath: '',
      errorNum: 0,
      tableRow: {},
      sortParams: {},
      searchFormData: {},
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
      imgIndex: 0
    };
  },
  computed: {},
  methods: {
    serlectRow(i, v) {
      this.model = i;
    },
    handleSelectionChange(val) {
      this.onRemoveSpuIds = [];
      console.log('val', val);
      val.forEach((x) => {
        this.onRemoveSpuIds.push(x.id);
      });
      this.selectSpus = val;
    },
    onSearch(foldId) {
      this.foldId = foldId || this.foldId;
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: 'folderId', //文件夹id
          val: [foldId || this.foldId],
          op: 'in',
        },
        {
          attributeName: 'fileName', //文件名
          val: this.searchForm.fileName ? this.searchForm.fileName : '',
          op: 'like',
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        // orderList: this.sortParams.type ?  [this.sortParams] : [],
        orderByColumn: '',
        orderType: '',
        hasCount: 'Y',
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/newProductPictureInfo`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.imgList = res.data.list ? this.tableData.list.map(v=>v.filePath) : []
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    videoShow(row,index) {
      this.imgFormVisible = true;
      this.imgIndex = index
      console.log(index);
      // let name = row.filePath.match(/\.([^\.]+)$/)[1]
      // if(name == 'tif' || name == 'TIF') {
      //   this.getTiffDataUrlHandler(row.filePath);
      // }else{
      //   this.imgList = [row.filePath]
      // }
    },
    //针对于tiff格式处理展示
    async getTiffDataUrlHandler (url) {
      const response = await fetch(url)
      const buffer = await response.arrayBuffer()
      try{
        const tiff = new Tiff({ buffer: buffer })
        this.imgList = [tiff.toDataURL()]
      }catch(err) {
        this.getTiffDataUrlHandler(url)
      }
    },
    resetTableSort() {
      this.$refs.tableRef.clearSort();
    },
    onSearchList() {
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      if (this.$refs.tableRef) {
        this.$refs.tableRef.clearSelection();
        this.$refs.tableRef.clearSort();
      }
      this.onSearch();
    },
    resetForm() {
      this.initSearchForm();
      this.onSearchList();
    },
    initSearchForm() {
      this.searchForm = {};
    },
    onSizeChange(pageSize) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = pageSize;
      this.loading = true;
      this.init(this.searchFormData);
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.loading = true;
      this.init(this.searchFormData);
    },
    getCaption(obj) {
      var index = obj.lastIndexOf('.'); //获取-后边的字符串
      obj = obj.substring(index + 1, obj.length);
      return obj;
    },
    downLoadRequest(filePath, fileName, index) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout((_) => {
        this.downloadRes(filePath, fileName);
        loading.close();
      }, 300);
    },
    async downloadRes(url, fileName, index) {
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName + '' + url.substring(url.lastIndexOf('.'));
      a.click();
      a.remove();
      if (this.selectSpus.length == index + 1) {
        setTimeout(() => {
          this.loadingAll.close();
        }, 500);
      }
    },
    async bacthoPeration(type) {
      if (!this.selectSpus.length) {
        this.$message.error('请选择后在进行操作');
        return;
      }
      if (type == 1) {
        //下载
        this.loadingAll = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        this.selectSpus.forEach((v, index) => {
          setTimeout(() => {
            this.downloadRes(v.filePath, v.fileName, index);
          }, 200 * index);
        });
      } else {
        //删除
        this.del(false, true);
      }
    },
    async del(row, type) {
      let status = await this.$confirm('确认删除当前文件？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let data = {
        fileIdList: type ? this.selectSpus.map((v) => v.fileId) : [row.fileId],
        folderId: type ? this.selectSpus[0].folderId : row.folderId,
      };
      this.$q.newProduct.pictureDel({ data: data }).then((res) => {
        if (res.code == 200) {
          this.$message.success('删除成功');
          this.onSearchList();
        }
      });
    },
    handleSortChange({ prop, order }) {
      this.sortParams = {
        type: order == 'ascending' ? 'asc' : order == 'descending' ? 'desc' : '',
        attributeName: prop,
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },

  mounted() {
    this.tableHeight = window.innerHeight - 220;
    // this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
>>> .content-panel {
  margin: 0 !important
}

>>> .el-dialog__headerbtn:hover .el-dialog__close{
  color: #FFF
}
</style>
